<template>
  <div class="Landing">
    <div class="content">
      <div :class="[{ active: shouldShowAccessibilityGate }]">
        <LottieWrapper :options="getOptions" :size="size" ref="Lottie_logo" :completeHandler="null" />
        <h5 ref="copy"><SplittingText :outDirection="2" :text="instructionCopy" ref="SplittingText" /></h5>
        <ContinueButton :onUserActivity="onUserActivity" :onClick="proceed" ref="ContinueButton" :copy="continueButtonCopy" state="begin" />
      </div>
      <div :class="[{ active: !shouldShowAccessibilityGate }, 'accessibilityGate']">
        <h5><SplittingText :outDirection="2" :text="locale.ACCESSIBILITY_MESSAGE" ref="accssibilityText"/></h5>
        <div class="proceedButton" @click="proccedWithoutAccessibility">
          <img src="@/assets/images/learn_more_bg.png" alt="Proceed button background">
            <span>{{ locale.ACCESSIBILITY_PROCEED }}
              <svg viewBox="0 0 32 32" class="icon icon-chevron-right">
                <path d="M18.629 15.997l-7.083-7.081L13.462 7l8.997 8.997L13.457 25l-1.916-1.916z"/>
              </svg>
            </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ContinueButton from '@/components/ContinueButton'
import LottieWrapper from '@/components/LottieWrapper'
import SplittingText from '@/components/SplittingText'

import * as animationData from '@/assets/svgs/LogoMain.json';

import { TimelineLite, Expo, TweenLite } from 'gsap'

export default {
  name: 'Landing',
  props: {
    onUserActivity: Function
  },
  components: {
    ContinueButton,
    LottieWrapper,
    SplittingText
  },
  data() {
    return {
      animationData: animationData,
      size: {
        width: 540,
        height: 310
      },
      showInstructions: false,
    }
  },
  mounted() {
    this.createAnimationTimeline()

    if ( !this.shouldShowAccessibilityGate ) {

      this.$refs.accssibilityText.animateTextIn()

    } else {

      this.animateElementsIn.play()
      this.$store.commit( 'resetSession' )
      this.$store.commit( 'setBackgroundVideoState', { isBackgroundVideoPlaying: true } )
      this.$store.commit( 'setHeaderVisibility', { isHeaderVisible: false } )
      this.$store.commit( 'setIsIdleLoopPlaying', { isIdleLoopPlaying: true } )
    }

  },
  beforeRouteLeave( to, from, next ) {

    this.$store.commit( 'setBackgroundVideoState', { isBackgroundVideoPlaying: false } )
    this.$store.commit( 'setTransitionVisibility', { isTransitionVisible: true } )

    setTimeout( () => { next() }, 450 )
  },
  computed: {
    isMobile() { return this.$store.state.isMobile },
    getOptions() {
      return {
        animationData: animationData.default,
        autoplay: false,
        loop: false
      }
    },
    instructionCopy() {
      return this.isMobile ? this.locale.LANDING_MOBILE : this.locale.LANDING_DESKTOP
    },
    continueButtonCopy() {
      return this.isMobile ? this.locale.LANDING_CONTINUE_MOBILE : this.locale.LANDING_CONTINUE_DESKTOP
    },
    shouldShowAccessibilityGate() { return this.$store.state.ui.isAccessibilityGatePassed },
    locale() { return this.$store.state.lang }
  },
  methods: {
    proccedWithoutAccessibility() {
      this.$store.commit( 'setIsAccessibilityGatePassed', { isAccessibilityGatePassed: true } )

      this.animateElementsIn.play()
    },
    proceed() {
      if ( !this.shouldShowAccessibilityGate ) return

      this.$store.commit( 'setSessionId', { sessionId: `RL${ Math.round( Math.random() * 10000 ) }` } )

      this.$router.push( { name: 'level', query: { lang: this.locale.LOCALE } } )
    },
    createAnimationTimeline() {
      const { Lottie_logo, ContinueButton, SplittingText } = this.$refs

      this.animateElementsIn = new TimelineLite( { paused: true } )

      this.animateElementsIn
        .add( () => { Lottie_logo.play() }, 1 )
        .add( () => { Lottie_logo.pause() }, 2 )
        .add( () => { SplittingText.animateTextIn() }, 1.2 )
        .add( () => { ContinueButton.animateElementsIn.play() }, 0.85 )
    },
  }
}
</script>

<style scoped lang="scss">

  @import '@/styles/core.scss';

  .Landing {

    height: 100%;
    width: 100%;

    min-height: $page-min-height;

    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    z-index: 1;

    @include breakpoint( mobile-all ) {

      min-height: 100%;

    }

    .accessibilityGate h5 {

      margin: 0 auto rem( 20 );
      max-width: rem( 600 );

    }

    .content {


      min-width: rem( 600 );

      @include breakpoint( mobile-all ) {

        min-width: 100%;

      }

      & > div {

        visibility: hidden;
        height: 0;

        &.active {

          visibility: visible;
          height: auto;

        }

      }

    }

    .proceedButton {

      position: relative;

      width: rem( 280 );
      height: rem( 60 );

      display: flex;
      justify-content: center;
      align-items: center;

      margin: 0 auto;

      cursor: pointer;

      @include uppercaseText();

      font-weight: 700;
      color: $color-turquoise;

      @include breakpoint( mobile-all ) {

        width: rem( 270 );
        height: rem( 60 );

      }

      img {

        width: 100%;
        height: 100%;

        position: absolute;
        top: 0;
        left: 0;

      }

      span {

        display: flex;
        justify-content: center;
        align-items: center;

        margin-left: rem( 20 );

        @include breakpoint( mobile-all ) {

          margin-left: rem( 15 );

        }

        svg {

          fill: $color-turquoise;
          width: rem( 20 );
          height: rem( 20 );

          @include breakpoint( mobile-all ) {

            width: rem( 15 );
            height: rem( 15 );

          }

        }

      }


    }

    .LottieWrapper {

      width: 100%;
      max-width: rem( 800 );
      margin: 0 auto rem( 60 );

      @include breakpoint( tablet ) {

        max-width: rem( 600 );

      }

    }

    h5 {

      @include uppercaseText();

      width: 85%;
      max-width: rem( 800 );

      margin: 0 auto rem( 120 );

    }


  }

</style>

<style lang="scss">

    .accessibilityGate h5 > div > span > a > span {
        text-decoration: underline;
    }

</style>
